import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface IssueCategoryTileFilter {
  IssueCategory: string;
}

@Component({
  standalone: true,
  selector: 'app-issue-category-dashboard',
  imports: [CommonModule],
  templateUrl: './issue-category-dashboard.component.html',
  styleUrl: './issue-category-dashboard.component.css',
})
export class IssueCategoryDashboardComponent {
  @Output() tileClick = new EventEmitter<IssueCategoryTileFilter>();

  categories: Array<{ count: number; label: string }> = [
    { count: 0, label: 'Financial Reporting' },
    { count: 0, label: 'Compliance Risk' },
    { count: 0, label: 'Operational Efficiency' },
  ];

  /** Issue-per-category counts from GetReviewDashboardCounts. */
  @Input() set issuePerCategory(value: any[]) {
    const list = Array.isArray(value) ? value : [];
    if (!list.length) return;
    this.categories = list.map(c => ({
      count: c.IssueCategoryCount ?? 0,
      label: c.IssueCategory,
    }));
  }

  selectIssueCategory(issueCategory: string): void {
    this.tileClick.emit({ IssueCategory: issueCategory });
  }
}
